import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { text } from '../assets/styles/utility';
import Icon from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesAvatarVariables = theme => ({
  background: theme.color.panel.base,
  color: theme.fontColor.base,
  size: {
    xsmall: theme.height.xsmall,
    small: theme.height.small,
    base: theme.height.base,

    get large() {
      return this.base * 2;
    }

  }
});

const StylesAvatarBase = (theme, props = {}) => [// 1. Fix issue with alignment of inlined avatars
{
  backgroundColor: StylesAvatarVariables(theme).background,
  borderRadius: theme.borderRadius.rounded,
  color: StylesAvatarVariables(theme).color,
  display: 'inline-flex',
  marginBottom: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'relative',
  width: StylesAvatarVariables(theme).size[props.size],
  height: StylesAvatarVariables(theme).size[props.size]
}];

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1vfhcql",
  styles: "object-fit:cover"
} : {
  name: "1960b8c-Avatar",
  styles: "object-fit:cover;label:Avatar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%"
} : {
  name: "k95bhj-Avatar",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;label:Avatar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Avatar = _ref => {
  let {
    className,
    fallbackIcon = 'user-circle',
    image,
    name,
    size = 'base'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "fallbackIcon", "image", "name", "size"]);

  const theme = useTheme();
  const [error, setError] = React.useState(false);
  const nameProp = name ? name.trim() : ''; // If image exists, use image for background

  if (image && !error) {
    return ___EmotionJSX("figure", _extends({
      css: [StylesAvatarBase(theme, {
        size
      }), process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"],
      className: clsx('CK__Avatar', className)
    }, rest), ___EmotionJSX("img", {
      loading: "lazy",
      alt: nameProp,
      onError: () => setError(true),
      src: image,
      css: _ref2
    }));
  } // If no image and no name, use icon


  if (!image && !nameProp) {
    return ___EmotionJSX("figure", _extends({
      css: [StylesAvatarBase(theme, {
        size
      }), process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"],
      className: clsx('CK__Avatar', className)
    }, rest), ___EmotionJSX(Icon, {
      icon: fallbackIcon,
      css: _ref3
    }));
  }

  let splitName = null;
  let initials = null;

  if (nameProp) {
    splitName = name.split(' ');
    initials = splitName[0][0] + splitName[splitName.length - 1][0];
  } // https://stackoverflow.com/a/48841447/1026742
  // For text alignment


  return ___EmotionJSX("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    css: [StylesAvatarBase(theme, {
      size
    }), process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"],
    className: clsx('CK__Avatar', className)
  }, rest), ___EmotionJSX("circle", {
    cx: "50",
    cy: "50",
    r: "50",
    css: [{
      fill: StylesAvatarVariables(theme).background
    }, process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"]
  }), ___EmotionJSX("text", {
    x: "50",
    y: "50",
    textAnchor: "middle",
    dy: "0.35em",
    fontSize: "40",
    css: [text.heading(theme), {
      fill: StylesAvatarVariables(theme).color,
      textTransform: 'uppercase'
    }, process.env.NODE_ENV === "production" ? "" : ";label:Avatar;"]
  }, initials));
};

export default Avatar;